import React from 'react'
import { LazyComponent } from '@offerzen/pinata'

const MobileWorkAuthorisationsLazy = props => (
  <LazyComponent
    // Hacky way to get around the component sharing redux state with employmentPreferences
    // TODO: Refactor to use react-query
    componentName="employmentPreferences"
    loader={() => import('./MobileWorkAuthorisationsScene')}>
    {MobileWorkAuthorisationsScene => (
      <Choose>
        <When condition={MobileWorkAuthorisationsScene}>
          <MobileWorkAuthorisationsScene {...props} />
        </When>
        <Otherwise>{/* TODO Add skeletons */}</Otherwise>
      </Choose>
    )}
  </LazyComponent>
)

export default MobileWorkAuthorisationsLazy
